/* sms-popup.js — Email signup modal (Shopify Email / Customers) */
'use strict';

(function () {
  var popup = document.getElementById('ccSmsPopup');
  if (!popup) return;

  var STORAGE_KEY = popup.dataset.storageKey || 'homestar_email_popup';
  var SESSION_KEY = STORAGE_KEY + '_session';
  var PENDING_KEY = 'homestar_email_pending';
  var delaySec = parseInt(popup.dataset.delay, 10) || 3;
  var dismissMinutes = parseInt(popup.dataset.dismissMinutes, 10) || 30;
  var dismissMs = dismissMinutes * 60 * 1000;
  var discountCode = popup.dataset.discountCode || 'HOMESTAR10';

  var form = document.getElementById('ccSmsPopupForm');
  var formView = document.getElementById('ccSmsPopupFormView');
  var successView = document.getElementById('ccSmsPopupSuccessView');
  var emailInput = document.getElementById('ccSmsEmail');
  var termsInput = document.getElementById('ccSignupTerms');
  var errorEl = document.getElementById('ccSmsPopupError');
  var copyBtn = document.getElementById('ccSmsCopyCode');
  var codeEl = document.getElementById('ccSmsDiscountCode');
  var showTimer = null;
  var lastFocus = null;

  function readState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeState(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* private browsing */ }
  }

  function readSessionShownAt() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      return raw ? parseInt(raw, 10) : null;
    } catch (e) {
      return null;
    }
  }

  function markSessionShown() {
    try {
      sessionStorage.setItem(SESSION_KEY, String(Date.now()));
    } catch (e) { /* private browsing */ }
  }

  function clearSessionShown() {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) { /* ignore */ }
  }

  function dismissCooldownExpired(dismissedAt) {
    return Date.now() - dismissedAt >= dismissMs;
  }

  function shouldShow() {
    var state = readState();
    if (state && state.submitted) return false;

    if (state && state.dismissedAt && !dismissCooldownExpired(state.dismissedAt)) {
      return false;
    }

    var sessionShownAt = readSessionShownAt();
    if (sessionShownAt && Date.now() - sessionShownAt < dismissMs) {
      if (!state || !state.dismissedAt || !dismissCooldownExpired(state.dismissedAt)) {
        return false;
      }
    }

    return true;
  }

  function getPreference() {
    var selected = form && form.querySelector('input[name="preference"]:checked');
    return selected ? selected.value : null;
  }

  function queueSignup(email, preference) {
    var entry = {
      email: email,
      preference: preference,
      ts: Date.now(),
      discountCode: discountCode,
      setPasswordUrl: window.HomestarMarketing && window.HomestarMarketing.config
        ? window.HomestarMarketing.config.setPasswordUrl
        : null
    };
    try {
      var queue = JSON.parse(localStorage.getItem(PENDING_KEY) || '[]');
      queue.push(entry);
      localStorage.setItem(PENDING_KEY, JSON.stringify(queue));
    } catch (e) { /* ignore */ }

    document.dispatchEvent(new CustomEvent('homestar:email-signup', {
      bubbles: true,
      detail: entry
    }));
  }

  function isOpen() {
    return popup.classList.contains('is-open');
  }

  function openPopup(fromUser) {
    if (showTimer) {
      window.clearTimeout(showTimer);
      showTimer = null;
    }
    if (isOpen()) return;

    var state = readState();
    if (state && state.submitted) {
      showSuccess();
    } else {
      if (formView) formView.hidden = false;
      if (successView) successView.hidden = true;
    }

    lastFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (!fromUser) markSessionShown();
    if (emailInput) emailInput.focus();
  }

  function closePopup(submitted) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    popup.hidden = true;
    document.body.style.overflow = '';

    if (submitted) {
      writeState({ submitted: true, at: Date.now() });
      clearSessionShown();
    } else {
      writeState({ dismissedAt: Date.now() });
    }

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showSuccess() {
    if (codeEl) codeEl.textContent = discountCode;
    if (formView) formView.hidden = true;
    if (successView) successView.hidden = false;
  }

  if (codeEl) codeEl.textContent = discountCode;

  popup.querySelectorAll('[data-sms-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var submitted = readState() && readState().submitted;
      closePopup(!!submitted || (successView && !successView.hidden));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup(successView && !successView.hidden);
    }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      var email = (emailInput && emailInput.value || '').trim();
      var emailOk = window.HomestarMarketing && typeof window.HomestarMarketing.isValidEmail === 'function'
        ? window.HomestarMarketing.isValidEmail(email)
        : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      var termsOk = !termsInput || termsInput.checked;

      if (!emailOk || !termsOk) {
        e.preventDefault();
        if (errorEl) {
          errorEl.textContent = 'Enter a valid email and accept the terms.';
          errorEl.hidden = false;
        }
        if (!emailOk && emailInput) emailInput.focus();
        else if (termsInput) termsInput.focus();
        return;
      }
      if (errorEl) errorEl.hidden = true;

      // Fold preference into Shopify customer tags before native submit.
      var preference = getPreference();
      var tagsInput = form.querySelector('input[name="contact[tags]"]');
      if (tagsInput) {
        var tags = tagsInput.value || 'newsletter, popup, shopify-email';
        if (preference && tags.indexOf('pref-') === -1) {
          tagsInput.value = tags + ', pref-' + preference;
        }
      }

      var returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = window.location.pathname + '?customer_posted=true&hs_popup=1';

      try {
        sessionStorage.setItem(STORAGE_KEY + '_pending', JSON.stringify({
          email: email,
          preference: preference,
          discountCode: discountCode,
          at: Date.now()
        }));
      } catch (err) { /* ignore */ }

      var btn = form.querySelector('.cc-sms-popup__submit');
      if (btn) {
        btn.disabled = true;
        btn.textContent = '...';
      }
      // Native submit — required for Shopify hCaptcha token.
    });
  }

  // After redirect back from Shopify customer form
  try {
    var q = new URLSearchParams(window.location.search);
    var pendingRaw = sessionStorage.getItem(STORAGE_KEY + '_pending');
    if ((q.get('customer_posted') === 'true' || q.get('hs_popup') === '1') && pendingRaw) {
      var pending = JSON.parse(pendingRaw);
      sessionStorage.removeItem(STORAGE_KEY + '_pending');
      queueSignup(pending.email, pending.preference || null);
      writeState({ submitted: true, at: Date.now(), email: pending.email });
      openPopup(true);
      showSuccess();
    }
  } catch (err) { /* ignore */ }

  if (copyBtn && codeEl) {
    copyBtn.dataset.label = copyBtn.textContent;
    copyBtn.addEventListener('click', function () {
      var text = codeEl.textContent;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          copyBtn.textContent = 'Copied';
          setTimeout(function () { copyBtn.textContent = copyBtn.dataset.label; }, 2000);
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = copyBtn.dataset.label; }, 2000);
      }
    });
  }

  var submitBtn = form && form.querySelector('.cc-sms-popup__submit');
  if (submitBtn) submitBtn.dataset.label = submitBtn.textContent;

  function togglePopup() {
    if (isOpen()) {
      closePopup(successView && !successView.hidden);
    } else {
      openPopup(true);
    }
  }

  var banner = document.getElementById('ccAnnouncementBar');
  if (banner) {
    banner.addEventListener('click', togglePopup);
  }

  if (shouldShow()) {
    showTimer = window.setTimeout(function () { openPopup(false); }, delaySec * 1000);
  }

  window.HomestarSmsPopup = {
    open: function () { openPopup(true); },
    close: function () {
      closePopup(!!(readState() && readState().submitted) || (successView && !successView.hidden));
    },
    toggle: togglePopup,
    isOpen: isOpen,
    getPendingSignups: function () {
      try {
        return JSON.parse(localStorage.getItem(PENDING_KEY) || '[]');
      } catch (e) {
        return [];
      }
    },
    clearPendingSignups: function () {
      try {
        localStorage.removeItem(PENDING_KEY);
      } catch (e) { /* ignore */ }
    }
  };
})();
